import { JSX } from "react";
import { toast } from "react-toastify";

function dismissToastQueued(): void {
  toast.dismiss();
}

function toastToastQueued(statement: string): void {
  toast.info(
    <ViewableFieldToastBody statement={statement} />,
    {
      closeOnClick: true,
      containerId: "z-index-9999",
      draggable: false,
    });
}

function toastError(statement: JSX.Element): void {
  toast.error(
    <ViewableFieldToastBody statement={statement} />,
    {
      containerId: "z-index-9999",
      draggable: false,
    }
  );
}

function ViewableFieldToastBody(props: { statement: string | JSX.Element }): JSX.Element {
  return (
    <span>{props.statement}</span>
  );
}

export {
  dismissToastQueued as dismiss,
  toastError,
  toastToastQueued as toastInfo,
};
